import { plantsActionTypes } from './plantsActionTypes';

const { LIST_PLANTS, FILTER_PLANT_NAME, FILTER_PLANT_FOR_FORM } =
	plantsActionTypes;

export const listPlants = (plants) => {
	return {
		type: LIST_PLANTS,
		payload: plants,
	};
};

export const filterPlantName = (plantName) => {
	return {
		type: FILTER_PLANT_NAME,
		payload: plantName,
	};
};

export const filterPlantforForm = (plantid) => {
	return {
		type: FILTER_PLANT_FOR_FORM,
		payload: plantid,
	};
};
